import React from "react";
import './ExhibitionDetails.css';

export default props => {
  const details = props.block.details || [];
  return (
    <div className="exhibition-details">
      <dl>
        {details.map((item, i) => (
          <React.Fragment key={i}>
            <dt>{item.label}</dt>
            <dd>{item.value}</dd>
          </React.Fragment>
        ))}
      </dl>
    </div>
  );
};
